<template>
    <ValidationObserver class="popup-add-domain" ref="form" v-slot="{handleSubmit}">
        <div class="flex mb-4">
            <div class="w-full mr-4">
                <ValidationProvider
                    vid="start"
                    :name="$t('settings.Start')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <vs-input class="w-full" type="time" :label="$t('settings.Start')" v-model="time.start" />
                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>
            <div class="w-full mr-4">
                <ValidationProvider
                    vid="end"
                    :name="$t('settings.End')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <vs-input class="w-full" type="time" :label="$t('settings.End')" v-model="time.end"/>
                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>
        </div>
        <div class="flex mb-4">
            <div class="w-full mr-4">
                <ValidationProvider
                    vid="asc"
                    :name="$t('settings.New')"
                    rules="required"
                    v-slot="{ errors }"
                >
                <label class="vs-input--label block w-full">{{$t('settings.New')}}</label>
                <v-select appendToBody :calculate-position="withPopper" :clearable="false" class="w-full" v-model="newd.selected" :options="newd.options" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>
            <div class="w-full mr-4">
                <ValidationProvider
                    vid="desc"
                    :name="$t('settings.Old')"
                    rules="required"
                    v-slot="{ errors }"
                >
                <label class="vs-input--label block w-full">{{$t('settings.Old')}}</label>
                <v-select appendToBody :calculate-position="withPopper" :clearable="false" class="w-full" v-model="old.selected" :options="old.options" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>
            <div class="w-full">
                <ValidationProvider
                    vid="timing"
                    :name="$t('settings.Timing')"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label class="vs-input--label block w-full">{{$t('settings.Timing')}}</label>
                    <v-select appendToBody :calculate-position="withPopper" :clearable="false" class="w-full" v-model="timing.selected" :options="timing.options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>
        </div>
        <div class="block text-right">
            <vs-button color="primary" @click="handleSubmit(editHold)" type="filled">{{$t('global.Save')}}</vs-button>
        </div>
    </ValidationObserver>
</template>

<script>
import vSelect from 'vue-select'
import {mapActions} from 'vuex'
import EventBus from '../../../store/eventBus'
import ErrorHandler from '@/utils/errorHandler'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {vSelectPosition} from "@/utils/mixins";

export default {
    mixins: [vSelectPosition],
    data() {
        return {
            time: {
                start: '00:01',
                end: '23:59'
            },
            timing: {
                selected: null,
                options: [
                    {label: '1', value: '1'},
                    {label: '5', value: '5'},
                    {label: '10', value: '10'},
                    {label: '15', value: '15'}
                ]
            },
            newd: {
                selected: null,
                options: [
                    {label: '0', value: '0'},
                    {label: '1', value: '1'},
                    {label: '2', value: '2'},
                    {label: '3', value: '3'},
                    {label: '4', value: '4'},
                    {label: '5', value: '5'}
                ]
            },
            old: {
                selected: null,
                options: [
                    {label: '0', value: '0'},
                    {label: '1', value: '1'},
                    {label: '2', value: '2'},
                    {label: '3', value: '3'},
                    {label: '4', value: '4'},
                    {label: '5', value: '5'}
                ]
            }
        }
    },

    props: {
        popupData: {
            type: Object,
            require: true
        },
        popupButton: {
            type: String
        },
        popupType: {
            type: String
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },

    methods: {
        ...mapActions(['EDIT_HOLD', 'CREATE_HOLD']),

        async editHold() {
            try {
                const data = {
                    id: this.popupData.id,
                    geo_id: this.popupData.geo,
                    is_active: this.popupData.is_active,
                    start: this.time.start,
                    end: this.time.end,
                    asc: this.newd.selected.value,
                    desc: this.old.selected.value,
                    timing: this.timing.selected.value
                }

                if(this.popupData.id) {
                    await this.EDIT_HOLD(data)
                } else {
                    delete data.id
                    await this.CREATE_HOLD(data)
                }

                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (error) {
                if(error.response.error) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }

                new ErrorHandler(error).send
            }
        }
    },

    mounted() {
        try {
            if(this.popupData.id) {
                this.time.start = this.popupData.start
                this.time.end = this.popupData.end
                this.timing.selected = {label: this.popupData.timing, value: this.popupData.timing}
                this.newd.selected = {label: this.popupData.asc, value: this.popupData.asc}
                this.old.selected = {label: this.popupData.desc, value: this.popupData.desc}
            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>
